<ul class="tree">
  @for (item of getFlatNodesWithLevel(tree); track trackById($index, item)) {
    <li class="tree-node" [style.marginLeft.px]="item.level * 20">
      <label class="node-line">
        <input
          type="checkbox"
          [checked]="isChecked(item.node.id)"
          (change)="toggleNode(item.node, $any($event.target).checked)"
          />
        <span class="node-text">
          {{ item.node.name }}
          <small class="muted">({{ item.node.label }})</small>
        </span>
      </label>
    </li>
  }
</ul>
